var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 4.58341C1.83325 4.07716 2.24366 3.66675 2.74992 3.66675H14.6666C15.1729 3.66675 15.5833 4.07716 15.5833 4.58341C15.5833 5.08967 15.1729 5.50008 14.6666 5.50008H2.74992C2.24366 5.50008 1.83325 5.08967 1.83325 4.58341Z",
    fill: "#161819"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 11.0002C1.83325 10.4939 2.24366 10.0835 2.74992 10.0835H19.2499C19.7562 10.0835 20.1666 10.4939 20.1666 11.0002C20.1666 11.5064 19.7562 11.9168 19.2499 11.9168H2.74992C2.24366 11.9168 1.83325 11.5064 1.83325 11.0002Z",
    fill: "#161819"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74992 16.5C2.24366 16.5 1.83325 16.9104 1.83325 17.4167C1.83325 17.9229 2.24366 18.3333 2.74992 18.3333H10.0833C10.5895 18.3333 10.9999 17.9229 10.9999 17.4167C10.9999 16.9104 10.5895 16.5 10.0833 16.5H2.74992Z",
    fill: "#161819"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.8145ed3262d7e66907f03319c16fbbbd.svg";
export { ForwardRef as ReactComponent };